import { ArrowRight } from "lucide-react";
import { useTranslation } from "@thyra/landing-i18n";
import { getAppUrl } from "../env";
import { SectionHeader } from "./ui/SectionHeader";

const STEPS = [
  { id: "describe", step: "1" },
  { id: "connect", step: "2" },
  { id: "run", step: "3" },
] as const;

export function HowItWorksSection() {
  const { t } = useTranslation("home");

  return (
    <section id="how-it-works" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={t("howItWorks.eyebrow")}
          title={t("howItWorks.title")}
          description={t("howItWorks.description")}
        />
        <ol className="relative mt-14 grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-6">
          {/* Connector line (desktop) */}
          <div
            className="pointer-events-none absolute left-[16%] right-[16%] top-[2.9rem] hidden h-px md:block"
            aria-hidden
          >
            <div className="step-line-draw h-full w-full bg-gradient-to-r from-primary/10 via-primary/40 to-primary/10" />
          </div>
          {STEPS.map(({ id, step }, i) => (
            <li
              key={id}
              data-aos="fade-up"
              data-aos-delay={i * 110}
              className="marketing-card marketing-card-hover relative p-6 pt-7"
            >
              <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-white">
                <span
                  className="absolute inset-0 rounded-full"
                  style={{ background: "var(--gradient-brand)" }}
                  aria-hidden
                />
                <span
                  className="absolute -inset-1 rounded-full border border-primary/20"
                  aria-hidden
                />
                <span className="relative">{step}</span>
              </span>
              <h3 className="mt-4 text-lg font-semibold tracking-tight text-card-foreground">
                {t(`howItWorks.steps.${id}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {t(`howItWorks.steps.${id}.body`)}
              </p>
            </li>
          ))}
        </ol>
        <div className="mt-12 flex justify-center">
          <a
            href={getAppUrl()}
            className="btn-brand group inline-flex h-11 items-center justify-center gap-2 rounded-xl px-7 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
          >
            {t("howItWorks.cta")}
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              strokeWidth={2}
            />
          </a>
        </div>
      </div>
    </section>
  );
}
